





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EnergyBar from './energy-bar.vue'

const actModule = namespace('freeOrder')

@Component({
  name: 'banners',
  components: {
    EnergyBar
  }
})
export default class Banners extends Vue {
  @Prop(Boolean) value!: boolean
  @actModule.Getter actEnd!: any
  progress = 0
  showMask = true
  imgCount = 1
  stopPenetrate() {
    return false
  }
  loaddingImg() {
    this.progress++
    if (this.progress === this.imgCount) {
      const doc = document as any
      doc.querySelector('#loadingDiv').style = 'display: none'
      this.$Collect.trackView('2020双12活动_loading页_加载时长', {}, {
        etype: 'time',
        page_name: 'loading页',
        ext_value: new Date().getTime() - (window as any).startTimestamp
      })
      this.showMask = false
    }
  }
}
